<!--
/*
 * Компонент [InstructionsDialog] — диалог выбора действия при клике на кнопку "Как подключить VPN".
 */
-->
<script setup lang="ts">
import { useI18n } from 'vue-i18n'

defineProps<{
  modelValue: boolean
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'open-instructions'): void
  (e: 'start-onboarding'): void
}>()

const { t } = useI18n()

function handleOpenInstructions() {
  emit('update:modelValue', false)
  emit('open-instructions')
}

function handleStartOnboarding() {
  emit('update:modelValue', false)
  emit('start-onboarding')
}
</script>

<template>
  <v-dialog
    :model-value="modelValue"
    max-width="440"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <v-card rounded="xl">
      <div class="d-flex flex-column ga-4 pa-6">
        <div class="text-h6 font-weight-bold">{{ t('instructions.howToConnect') }}</div>

        <v-btn
          variant="flat"
          color="surface"
          class="text-on-surface"
          rounded="lg"
          block
          prepend-icon="ri-file-list-3-line"
          @click="handleOpenInstructions"
        >
          {{ t('instructions.openInstructions') }}
        </v-btn>

        <v-btn
          variant="flat"
          color="surface"
          class="text-on-surface"
          rounded="lg"
          block
          prepend-icon="ri-compass-3-line"
          @click="handleStartOnboarding"
        >
          {{ t('instructions.howToUseApp') }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
